<script>
    import { PATH_PREFIX } from '../../apiUrls.js';
    export let row;

    function onClick() {
        if(row.activity_version_id) {
            window.open(`${PATH_PREFIX}/sw/builder/activityversion/${row.activity_version_id}/pdf-instructions-status/`);
        }
    }

    const STATUS_COLORS = {
        "Success": "#5CB85C",
        "Pending": "#0DA2FF",
        "Retryable Fail": "#F47B2E",
        "Fail": "#DD3B00",
        DEFAULT: "#DD3B00"
    };

    $: backgroundColor = STATUS_COLORS[row.publication_status] || STATUS_COLORS.DEFAULT;
    $: cursorStyle = row.activity_version_id ? 'pointer' : 'default';
</script>

{#if row.publication_status}
  <span
    style="border-radius: 10rem; padding: 4px 10px; background-color: {backgroundColor}; color: white; cursor: {cursorStyle};"
    on:click={onClick}
  >
    {row.publication_status_display_name}
  </span>
{/if}
